<template>
  <!-- 表单项组件模板
        @author liuguisheng
        @date 2019-9-10
  -->
  <div class="item-template" 
       :class="{active:isActivated, [formType]:true}"
       v-if="formConfig"
       @click.stop="onActive">
    <!-- 表单项渲染 -->
    <component :formNode="formNode"
               :is="formType && 'form-item-'+formType">
    </component>
    <!-- 自定义名称右上角显示 -->
    <span class="custom-wrap">{{customName}}</span>
    <!-- 表单项遮盖层 -->
    <div class="mark-wrap" v-show="['grid', 'free'].includes(formType) == false"></div>
    <!-- 表单项操作条(拖动、赋值、删除) -->
    <i v-show="isActivated" 
       class="drag-bar iconfont iconmove"></i>
    <i v-show="isActivated"
       class="copy-bar iconfont iconcopy" 
       @click.stop="onCopy"></i>
    <i v-show="isActivated" 
       class="delete-bar iconfont icondelete" 
       @click.stop="onDelete"></i>
  </div>
</template>

<script>
// 导入拖拽表单混入文件
/** 混入方法 ::: 
 *  @mixins mixFormItemTemplate 表单项模版混入
 */
import { mixFormItemTemplate } from "@/mixins/form_item/mix_form_item_template.js";


export default {
  name: "formItemTemplate",
  mixins: [ mixFormItemTemplate ],
  props: {
    // 表单项对象
    formNode: {
      type: Object,
      required: true
    },
    // 表单项父级
    formParent: {
      type: Array,
      required: true
    }
  },
  computed: {
    /** @name 当前表单项是否激活
     *  @return {Boolean}
     *  @author 王汝鹏
     *  @version 2019-09-14
     */
    isActivated() {
      //  判断当前表单项是否为激活表单项
      return this.formNodeManager(this.formNode).isEqual(this.activeNode);
    },
  },  
  methods: {
    /** @name 激活表单项
     *  @author 王汝鹏
     *  @version 2019-09-14
     */
    onActive() {
      this.formListManager().activeNode(this.formNode, this.formParent);
    },
    /** @name 复制表单项
     *  @author 王汝鹏
     *  @version 2019-09-14
     */
    onCopy() {
      let copyIndex = this.formParent.findIndex(node => this.formNodeManager(this.formNode).isEqual(node));
      let copyNode = this.formNodeManager(this.formNode).copy();
      this.formParent.splice(copyIndex+1, 0, copyNode);
      this.formListManager().refreshList();
    },
    /** @name 删除表单项
     *  @author 王汝鹏
     *  @version 2019-09-14
     */
    onDelete() {
      let deleteIndex = this.formParent.findIndex(node => node === this.formNode);
      if (deleteIndex === -1) return;

      //  删除表单项
      this.formNodeManager(this.formNode).deleteFrom(this.formParent);

      //  激活表单项规则: 
      //    1. 正常情况下激活删除的前一个表单项
      //    2. 如果删除的是第一个元素，激活第一个元素
      //    3. 如果删除后没有元素了就没有激活项
      deleteIndex > 0 
        ? this.formListManager().activeNode(this.formParent[deleteIndex-1] || {}, this.formParent)
        : this.formListManager().activeNode(this.formParent[deleteIndex] || {}, this.formParent)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form_item/FormItemTemplate.vue